import { useMemo } from "react";
import React from "react";
import { UseFormFieldProps } from "../types/form-types";

export const useFormField = ({
  name,
  formContext,
  disabled,
  style = {},
}: UseFormFieldProps) => {
  const { values, errors, touched } = formContext;
  const value = values[name] || "";
  const error = touched[name] && errors[name];

  const inputStyle: React.CSSProperties = useMemo(
    () => ({
      padding: "10px 12px",
      fontSize: "14px",
      border: error ? "2px solid #ef4444" : "1px solid #d1d5db",
      borderRadius: "8px",
      outline: "none",
      backgroundColor: disabled ? "#f3f4f6" : "#ffffff",
      color: disabled ? "#9ca3af" : "#1f2937",
      transition: "border-color 0.2s",
      ...style,
    }),
    [error, disabled, style]
  );

  const labelStyle: React.CSSProperties = {
    display: "block",
    fontSize: "14px",
    fontWeight: "500",
    color: "#374151",
    marginBottom: "4px",
  };

  const containerStyle: React.CSSProperties = {
    marginBottom: "16px",
    width: "100%",
  };

  const errorStyle: React.CSSProperties = {
    marginTop: "4px",
    fontSize: "12px",
    color: "#ef4444",
  };

  const helperStyle: React.CSSProperties = {
    marginTop: "4px",
    fontSize: "12px",
    color: "#6b7280",
  };

  return {
    value,
    error,
    inputStyle,
    labelStyle,
    containerStyle,
    errorStyle,
    helperStyle,
  };
};
